import React, { useEffect, useState } from "react";
import { Contact2 } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { PageHeader, EmptyState, Loader } from "@/components/dashboard/ui";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LEAD_STATUSES } from "@/data/constants";
import { useSelect, SelectCheck, SelectionToolbar } from "@/components/admin/BulkBar";

export default function AdminLeads() {
  const [leads, setLeads] = useState(null);
  const [arch, setArch] = useState(false);
  const sel = useSelect();
  const load = () => api.get(`/leads?include_archived=${arch}`).then(({ data }) => setLeads(data || []));
  useEffect(() => { sel.clear(); load(); /* eslint-disable-next-line */ }, [arch]);
  const setStatus = async (l, status) => {
    try { await api.put(`/leads/${l.lead_id}`, { status }); toast.success("Statut mis à jour"); load(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  if (leads === null) return <Loader />;
  return (
    <div>
      <PageHeader title="Prospects" subtitle="Demandes reçues via le site public." />
      <SelectionToolbar items={leads} idKey="lead_id" sel={sel} entity="leads" onDone={load} label="prospect" archived={arch} onToggleArchived={() => setArch((a) => !a)} />
      {leads.length === 0 ? <EmptyState icon={Contact2} title={arch ? "Aucun prospect archivé" : "Aucun prospect"} /> : (
        <div className="space-y-3">{leads.map((l) => (
          <div key={l.lead_id} className={`relative bg-white rounded-xl border p-5 pl-11 ${sel.has(l.lead_id) ? "border-primary ring-1 ring-primary/30" : "border-slate-200"}`} data-testid={`lead-${l.lead_id}`}>
            <SelectCheck className="absolute left-3 top-6" checked={sel.has(l.lead_id)} onChange={() => sel.toggle(l.lead_id)} testId={`select-lead-${l.lead_id}`} />
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap"><span className="font-semibold text-slate-900">{l.first_name} {l.last_name}</span><span className="text-sm text-slate-400">{l.practice}</span></div>
                <p className="text-sm text-slate-500 mt-0.5">{l.email} · {l.phone} · {l.city} {l.canton}</p>
                <p className="text-sm text-slate-600 mt-1.5">{(l.services || []).join(", ")}</p>
                {l.description && <p className="text-sm text-slate-400 mt-1 italic">« {l.description} »</p>}
                <p className="text-xs text-slate-400 mt-2">Reçu le {new Date(l.created_at).toLocaleDateString("fr-CH")} · Source : {l.source}</p>
              </div>
              <Select value={l.status} onValueChange={(v) => setStatus(l, v)}><SelectTrigger className="w-44" data-testid={`lead-status-${l.lead_id}`}><SelectValue /></SelectTrigger><SelectContent>{LEAD_STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent></Select>
            </div>
          </div>))}
        </div>
      )}
    </div>
  );
}
